import {addClass, getCookie, makeElement, removeClass, setCookie} from '../../common/Utils';
import { ncBannerOptions } from '../../interface/ICommonbanner';
import { replaceLocale, setStartEndDateTime } from '../utils/Utils';

/**
 * @category Commonbanner
 * @description
 * 토스트 배너
 * 서브페이지에서만 노출
 * 단, 플로팅 배너가 활성화 되어 있으면 노출 하지 않음
 * 닫기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */

class ToastLayer {
    isCookieApply: boolean;
    bannerEl!: HTMLElement;
    el!: HTMLElement;

    constructor(_isMain: boolean = false, _isLauncher:boolean = false, _data:ncBannerOptions, useCookie: boolean) {
        this.isCookieApply = useCookie;

        let thisIsCookieApply = this.isCookieApply && getCookie(_data.toastBanner.Cookie);

        if( _isMain || !_data.toastBanner.show || thisIsCookieApply || _data.floatingBanner.show){
            return;
        }

        if ( _isLauncher && !_data.toastBanner.LauncherShow ) {
            return;
        }

        setStartEndDateTime(_data, _data.toastBanner, this.templateToast.bind(this));


    }

    templateToast(_data: ncBannerOptions){
        this.bannerEl = this.template( _data ) ;

        document.body.appendChild( this.bannerEl );
        this.addEvents(_data);

        setTimeout(()=> {
            addClass( this.bannerEl , 'is-show');
        }, 1000);
    }

    template(_data: ncBannerOptions){
        this.el = makeElement( `

            <div class="nc-banner" data-type="toast">
             ${_data.toastBanner.Link != ''?`
                 <a href="${replaceLocale(_data.toastBanner.Link!)}" ${_data.toastBanner.LinkNewWindow ? 'target=_blank' :''} class="nc-banner-link" style="background-image:url('${_data.toastBanner.BG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.toastBanner.Lable}</div>
                        <strong class="nc-banner-title-main">${_data.toastBanner.Title}</strong>
                        <em class="nc-banner-title-sub">${_data.toastBanner.SubTitle}</em>
                    </div>
                </a>
            ` : `
               <span class="nc-banner-link" style="background-image:url('${_data.toastBanner.BG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.toastBanner.Lable}</div>
                        <strong class="nc-banner-title-main">${_data.toastBanner.Title}</strong>
                        <em class="nc-banner-title-sub">${_data.toastBanner.SubTitle}</em>
                    </div>
                </span>
            `}


                <button class="nc-banner-close"><span class="blind">그만보기</span></button>
            </div>
        ` );

        return this.el;
    }


    addEvents(_data: ncBannerOptions){
        const dataTypeToast = document.querySelector(".nc-banner[data-type=toast]") as HTMLElement;
        document.querySelector(".nc-banner[data-type=toast] .nc-banner-close")?.addEventListener('click', e =>{

            // console.log( '=> ToastLayer.js constructor: this.isCookieApply : ', this.isCookieApply  );
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.toastBanner.Cookie, "true", 100, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.toastBanner.Cookie, "true", 100, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.toastBanner.Cookie, "true", 100, '.plaync.com');
            }
            removeClass( dataTypeToast , 'is-show');
        });
    }

}
export default ToastLayer;
